import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'

import { REGEX } from 'utils/validations'
import { CONTACT_METHODS, supportsPhoneExtension } from 'settings/constants/contacts'
import { HHFormTextField } from 'components/form-fields/v5'
import HHFormPhoneField from 'components/form-fields/v5/HHFormPhoneField'

import T from 'T'

const { EMAIL } = CONTACT_METHODS

const ContactMethodValueFields = ({
  control,
  methodType,
  methodValue = '',
  methodPhoneExtension = '',
  valueFieldName,
  extensionFieldName,
  error = undefined,
}) => {
  if (methodType === EMAIL) {
    return (
      <Grid size={12}>
        <HHFormTextField
          value={methodValue}
          control={control}
          error={error}
          rules={{ pattern: REGEX.IS_EMAIL }}
          name={valueFieldName}
          label={methodType}
          fullWidth
          deprecatedLabel={false}
        />
      </Grid>
    )
  }

  // Extension only applies to Phone/Mobile — Fax (and any future non-phone
  // type) gets a single full-width phone-style input with no extension.
  const showExtension = supportsPhoneExtension(methodType)
  return (
    <>
      <Grid size={showExtension ? 8 : 12}>
        <HHFormPhoneField
          value={methodValue}
          control={control}
          error={error}
          rules={{ pattern: REGEX.IS_VALID_MOBILE }}
          name={valueFieldName}
          label={methodType}
          fullWidth
          deprecatedLabel={false}
        />
      </Grid>
      {showExtension && (
        <Grid size={4}>
          <HHFormTextField
            value={methodPhoneExtension}
            control={control}
            name={extensionFieldName}
            label={T.EXTENSION}
            fullWidth
            deprecatedLabel={false}
            regexValidators={[/^[\d*#]*$/]}
            inputProps={{ maxLength: 15, inputMode: 'tel' }}
          />
        </Grid>
      )}
    </>
  )
}

ContactMethodValueFields.propTypes = {
  control: PropTypes.object.isRequired,
  methodType: PropTypes.string,
  methodValue: PropTypes.string,
  methodPhoneExtension: PropTypes.string,
  valueFieldName: PropTypes.string.isRequired,
  extensionFieldName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.any,
}

export default ContactMethodValueFields
